export default __webpack_public_path__ + "static/media/034.1d324bfd.jpg";